import { Skeleton } from '@/components/ui/skeleton';

const MessagePreviewSkeleton = ({ style = {} }) => {
  return (
    <div className="flex w-full flex-col pt-1" style={style}>
      <div className="flex gap-2 rounded px-1.5 pt-1.5 pb-2 hover:bg-muted">
        {/* Left: name + preview */}
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <Skeleton className="h-3.5 w-32" />
          <Skeleton className="h-3 w-40" />
        </div>

        {/* Right: icons + timestamp */}
        <div className="flex shrink-0 flex-col items-end gap-1">
          <div className="flex items-center gap-1">
            <Skeleton className="size-4 rounded-full" />
            <Skeleton className="size-4 rounded-full" />
          </div>
          <Skeleton className="h-3 w-8" />
        </div>
      </div>
    </div>
  );
};

export default MessagePreviewSkeleton;
